import { ProductGroupMultiselectFilter, SideFilters } from '@retail/components';
import { SelectDiscountGroups, SelectSuppliersAutocomplete } from '../MgSupplierItem';
import { MgSupplierItemSearchField } from '../MgItem';
import { DiscountGroup, ProductGroup, ProductGroupCount } from '@retail/products/types';
import { SupplierBase } from '@retail/suppliers/types';
import { useFilters } from '@retail/products/hooks';
import { BulkActionsFilters, itemBulkActions } from '@retail/products/utils';

interface Props {
  showFilters: { isOpen: boolean; onClose: () => void };
  suppliers: SupplierBase[];
  discountGroups: DiscountGroup[];
  productGroupHierarchy: ProductGroupCount[];
}

export function BulkEditFilter({
  showFilters,
  suppliers,
  discountGroups,
  productGroupHierarchy,
}: Props) {
  const { filters, setFilters, updateFilter } = useFilters<BulkActionsFilters>(itemBulkActions);

  return (
    <SideFilters showFilters={showFilters.isOpen} sx={{ py: 1 }}>
      <SelectSuppliersAutocomplete
        suppliers={suppliers}
        selectedSupplierNumbers={filters.supplierModal.map(Number)}
        isFetching={false}
        selectSuppliers={(supplierNumbers: number[]) =>
          setFilters({ supplierModal: supplierNumbers.map(String) })
        }
      />

      <SelectDiscountGroups
        discountGroups={discountGroups}
        selectedDiscountGroups={filters.discountGroupModal.map(Number)}
        getDiscountGroupKey={({ id }: DiscountGroup) => id}
        selectDiscountGroups={(discountGroupIds: number[]) =>
          setFilters({ discountGroupModal: discountGroupIds.map(String) })
        }
      />

      <MgSupplierItemSearchField
        searchTerm={filters.searchQueryModal ?? undefined}
        isDisabled={false}
        size="small"
        onSubmitSearch={(query: string) => setFilters({ searchQueryModal: query })}
      />
      <ProductGroupMultiselectFilter
        productGroups={productGroupHierarchy}
        selectedProductGroups={filters.productGroupModal}
        selectProductGroup={(groupNumber: string) => updateFilter('productGroupModal', groupNumber)}
        getCount={(productGroup: ProductGroup) => productGroup.count}
      />
    </SideFilters>
  );
}
